/**
 * Tokens de design partagés par le layout utilisateur.
 * Une seule palette pour sidebar, header et menu mobile.
 */
/* Panel "verre" autoporté en contraste (ne dépend plus d'un fond dégradé
   coloré derrière lui pour rester lisible) : carte blanche nette en clair,
   verre sombre en sombre — combiné à `textPrimary`/`textSecondary` pour le
   texte plutôt qu'un blanc figé. */
export const glassPanel =
  "bg-white dark:bg-ink-950/80 backdrop-blur-lg rounded-2xl shadow-xl shadow-ink-900/5 dark:shadow-ink-950/40 border border-ink-900/10 dark:border-ink-700";
export const surface = "bg-white dark:bg-ink-800";
export const surfaceMuted = "bg-ink-100 dark:bg-ink-700/50";
export const borderSub = "border-ink-900/10 dark:border-ink-700";
export const btnActive = "bg-ember-600 dark:bg-ember-600 text-white";
export const btnHover = "hover:bg-ink-100 dark:hover:bg-ink-700";
export const textPrimary = "text-ink-900 dark:text-white";
export const textSecondary = "text-ink-500 dark:text-ink-400";
export const roundedPanel = "rounded-xl";
export const roundedBtn = "rounded-lg";
